import { renderSlot as _renderSlot, TransitionGroup as _TransitionGroup, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.group)
    ? (_openBlock(), _createBlock(_TransitionGroup, {
        key: 0,
        tag: "span",
        class: "transition-group",
        name: $props.name
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["name"]))
    : (_openBlock(), _createBlock(_Transition, {
        key: 1,
        name: $props.name
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["name"]))
}